import React, { useEffect, useState, PureComponent } from 'react';
import { useParams } from 'react-router-dom';
import { useForm } from "react-hook-form";

import Video from "./Video";
import Mint from "./Mint";
import Bio from "./Bio";
import Quiz from "./Quiz";
import Ar from "./Ar";
import Download from "./Download";

import ActivityIcon from './ActivityIcon';

import module from '../assets/module.svg';
import rocket from '../assets/rocket.png';
import user from '../assets/user.png';

import poll from '../assets/poll_big.png';
import questions from '../assets/questions.png';
import video from '../assets/video.png';
import download from '../assets/download.png';
import ar from '../assets/AR_big.png';
import profile from '../assets/module_profile.png';

import { ReactComponent as Eye } from '../assets/eye.svg';
import { ReactComponent as Qrcode } from '../assets/qrcode_small.svg';
import { ReactComponent as Add } from '../assets/add_black.svg';
import { ReactComponent as Cancel } from '../assets/cancel.svg';
import { ReactComponent as EditPurple } from '../assets/edit_purple.svg';
import { ReactComponent as QrcodePurple } from '../assets/qrcode_purple.svg';
import { ReactComponent as Remove } from '../assets/remove.svg';
import { ReactComponent as EditSvg } from '../assets/edit.svg';

import { db, storage } from "../firebase";
import { doc, getDocs, getDoc, collection, onSnapshot, setDoc, updateDoc, addDoc } from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";


export default function ActivitySettings ({type, close, addActivity, module_activity, removeActivity, moduleId, activityId}) {
    
    moduleId++; //start from 1, not from 0
    activityId++; //start from 1, not from 0

    useEffect(() => {
        if (module_activity){
            setActivity(module_activity);
            document.getElementById("settings").reset();
        }
    }, [module_activity]);

    if(!module_activity){
        
        switch(type){
            case '/quiz':

                module_activity = 
                    {
                        data: {                
                            answer1: '',
                            answer2: '',
                            answer3: '',
                            answer4: '',
                            popup: 'Thank you! We\'ll keep that in mind.',                 
                            question: '',
                            taskDescription: 'Answer the question correctly to get 5 points',
                        },
                        id: activityId,
                        link: type,
                        name: '',
                        packet_id: "packet_"+moduleId,
                        points: 5,
                        progressRef: 'quiz',            
                        //icon: "quiz.png",
                        icon: 'https://firebasestorage.googleapis.com/v0/b/lagoon-saas.appspot.com/o/activities%2Fquiz.png?alt=media&token=bef85305-fcd7-4963-9f05-36b47d125410',
                        
                    };
                break;
                
            case '/video': 
                
                module_activity = 
                    {
                        link: type,
                        name: "Watch Video",
                        points: 5,
                        progressRef: "video",
                        data: {
                            taskDescription:
                                "for watching this video you can have up to 5 points depending on how long you've watched.",
                            url: "",
                        },
                        id: activityId,
                        packet_id: "packet_"+moduleId,                        
                        //icon: "video.png",
                        icon: 'https://firebasestorage.googleapis.com/v0/b/lagoon-saas.appspot.com/o/activities%2Fvideo.png?alt=media&token=8c852508-11b1-44b0-bd4b-bf7e1335d7d3',
                    };
                break;
                
            case '/poll': 
                
                module_activity = 
                    {
                        data: {                
                            answer1: '',
                            answer2: '',
                            answer3: '',
                            answer4: '',
                            popup: 'Thank you for download',                 
                            question: '',
                            taskDescription: 'Answer the poll correctly to get 5 points',
                        },
                        id: activityId,
                        link: type,
                        name: '',
                        packet_id: "packet_"+moduleId,
                        points: 5,
                        progressRef: 'poll',
                        icon: 'https://firebasestorage.googleapis.com/v0/b/lagoon-saas.appspot.com/o/activities%2Fquiz.png?alt=media&token=bef85305-fcd7-4963-9f05-36b47d125410',
                        
                    };
                break;
                
            case '/download':
                
                module_activity = 
                    {
                        data: {                
                            assetUrl: '',
                            popup: 'Thank you for download',
                            taskDescription: 'Download to get 5 points',
                            buttonText: '',
                        },
                        id: activityId,
                        link: type,
                        name: '',
                        packet_id: "packet_"+moduleId,
                        points: 5,
                        progressRef: 'download',
                        icon: 'https://firebasestorage.googleapis.com/v0/b/lagoon-saas.appspot.com/o/activities%2Fpdf.png?alt=media&token=de84b12a-3a0e-4bc7-9166-0d66c44e99af'
                        
                    };
                break;
                
            case '/ar':
                
                module_activity = 
                    {
                        data: {                
                            arUrl: '',
                            popup: 'Thank you',
                            taskDescription: '',
                            buttonText: '',
                        },
                        id: activityId,
                        link: type,
                        name: '',
                        progressRef: 'ar',
                        packet_id: "packet_"+moduleId,
                        points: 5,
                        icon: 'https://firebasestorage.googleapis.com/v0/b/lagoon-saas.appspot.com/o/activities%2Far.png?alt=media&token=4071860b-d909-4d69-b020-22bbc95d2b35',
                        
                    };
                break;     
                
            case '/mint':
                
                module_activity = 
                    {
                        data: {
                            taskDescription: "You can earn 10 points for minting your NFT",
                        },
                        id: activityId,
                        link: type,
                        name: 'Mint your NFT',
                        packet_id: "packet_"+moduleId,
                        points: 10,
                        progressRef: "mint",
                        //icon: "mint.png",
                        icon: 'https://firebasestorage.googleapis.com/v0/b/lagoon-saas.appspot.com/o/activities%2Fmint.png?alt=media&token=db00d784-8514-4758-90ad-363d85a5c29e',
                        
                    };
                break;     
                
            case '/bio':
                
                module_activity = 
                    {
                        data: {
                            taskDescription: "You can earn 10 points",
                        },
                        id: activityId,
                        link: type,
                        name: 'Complete your profile',
                        packet_id: "packet_"+moduleId,
                        points: 10,
                        progressRef: "bio",
                        //icon: "bio.png",
                        icon: 'https://firebasestorage.googleapis.com/v0/b/lagoon-saas.appspot.com/o/activities%2Fbio.png?alt=media&token=1fc303d0-9b16-4d00-a577-0a0e19487722',
                        
                    };
                break;   
                                
        }    
    }

    const [activity, setActivity] = useState(module_activity);    
    
    
    
    const {
        register,
        reset,
        handleSubmit,
        formState: { errors },
    } = useForm();    
    
    const remove = () => {
        
        removeActivity();        
        close();
    }
    
    //=== save ===
    
    const [message, changeMessage] = useState('');        
    const setMessage = (text) => {
        changeMessage(text)
        setTimeout(() => {
            changeMessage();
        }, 3000);
    };    
    const save = async (data) => {
        
        Object.assign(activity, data)
        setActivity(activity);
        
        addActivity (activity);
        
    }     

    const [imgUrl, setImgUrl] = useState(null);
    const [progresspercent, setProgresspercent] = useState(0);
    const [fileError, setFileError] = useState('');
    const saveButton = async (data) => {        
                
        console.log(data);
        //download
        if(type == '/download'){            
            if(typeof(data['data']['assetUrl'][0]) == 'undefined' && data['data']['assetUrl_last_value'] == ''){
                console.log('error1');
                setFileError ("File is required");
                return;
            }
            
            if (typeof(data['data']['assetUrl'][0]) !== 'undefined'){
                
                const file = data['data']['assetUrl'][0];
                const storageRef = ref(storage, `upload/${file.name}`);
                const uploadTask = uploadBytesResumable(storageRef, file);

                uploadTask.on("state_changed",
                (snapshot) => {
                    
                    const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                    console.log('progress = ' + progress);
                    setProgresspercent(progress);
                },
                (error) => {
                    
                    console.log(error);
                    setFileError ("Can't upload file. "+error);
                    return;
                },
                () => {
                    
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    
                        data['data']['assetUrl'] = downloadURL;
                        data['data']['fileName'] = file.name;
                        
                    });
                }
                );
            } else {
                data['data']['assetUrl'] = data['data']['assetUrl_last_value'];                
            }
            delete data['data']['assetUrl_last_value']
            
            console.log(data);
        
        }
        
        data['temp_icon'] = activityImage;
        data['temp_reward_icon'] = rewardImage;

            
        save (data);
        close();
    }  
    
    //============================================================
    //  icons 
    
    
    
    const [isShowIcon, setShowIcon] = useState(false);
    const [removeIcon, setRemoveIcon] = useState(false);   
    const [activityIcon, setActivityIcon] = useState(activity['icon']);
    
    useEffect(() => {

        //console.log('======+======'+module_activity['icon'])

        setActivityIcon(activity['icon']);


    }, [module_activity]);
    
    //console.log('===');
    //console.log(defaultIcon);
    
//     if (!!activity['icon'])
//         setActivityIcon(activity['icon']);
    
    
    const [activityImage, setActivityImage] = useState(false);
    const saveIcon = (file) => {

        setActivityImage(file);

        const objectUrl = URL.createObjectURL(file);
        setActivityIcon(objectUrl);
        activity['icon'] = objectUrl;


        //setSelectedFile(file);
        
        if (file)
            setRemoveIcon(false);
        else
            setRemoveIcon(true);        
        
    }


    const hideIcon = (event) => {
        setShowIcon(false);
    }

    /*** Reward ***/

    const [rewardImage, setRewardImage] = useState(false);

    useEffect(() => {

        if (activity['reward'] && activity['reward']['image'])
            setRewardImage(activity['reward']['image']);

	}, [activity]);

    const saveRewardIcon = (file) => {

        setRewardImage(file);

        const objectUrl = URL.createObjectURL(file);
        if (!activity['reward'])
            activity['reward'] = [];
        activity['reward']['image'] = objectUrl;
    }

    const hideRewardIcon = (event) => {
    }


    //============================================================
    
    return (
        
        <div className="right">                                         
                                        
            <div className="settings dashed-border">             
            
                <form id="settings">
                
                    {
                        {
                            '/quiz':        
                            
                                <Quiz icon={activityIcon} saveIcon={saveIcon} hideIcon={hideIcon} name="Quiz" activity={activity} remove={remove} errors={errors} register={register}/>
                            ,
                            '/poll':
                            
                                <Quiz icon={activityIcon} saveIcon={saveIcon} hideIcon={hideIcon} name="Poll" activity={activity} remove={remove} errors={errors} register={register}/>
                            ,
                            '/video':   
                            
                                <Video icon={activityIcon} saveIcon={saveIcon} hideIcon={hideIcon} name="Video" activity={activity} remove={remove} errors={errors} register={register}/>
                            ,                            
                            '/mint':   
                            
                                <Mint icon={activityIcon} saveIcon={saveIcon} hideIcon={hideIcon} name="Mint" activity={activity} remove={remove} errors={errors} register={register}/>
                            ,
                            '/bio':   
                            
                                <Bio icon={activityIcon} saveIcon={saveIcon} hideIcon={hideIcon} name="Bio" activity={activity} remove={remove} errors={errors} register={register}/>
                            ,
                            '/download':    
                                
                                <Download icon={download} name="Download" activity={activity} remove={remove} errors={errors} register={register} fileError={fileError}/>
                            ,
                            '/profile':     
                                <></>
                            ,
                            '/ar':   
                            
                                <Ar icon={activityIcon} saveIcon={saveIcon} hideIcon={hideIcon} name="AR" activity={activity} remove={remove} errors={errors} register={register}/>
                            ,
                            '/photobooth':  
                                <></>
                            ,
                            '/matchgame':   
                                <></>

                        }[type]
                    }
                
                    <div className="subtitle">Task description</div>
                    <input 
                        type="text"
                        {...register("data[taskDescription]", { required: "Task description is required" })}
                        placeholder="Task description"
                        defaultValue={activity['data']['taskDescription']}
                    />
                    <div className="error">{errors["data"] ? errors["data"]["taskDescription"]?.message : '' }</div>
                    
                    <div className="subtitle">Popup</div>
                    <input 
                        type="text"
                        {...register("data[popup]", { required: "Popup is required" })}
                        placeholder="Thank you"
                        defaultValue={activity['data']['popup']}
                    />
                    <div className="error">{errors["data"] ? errors["data"]["popup"]?.message : '' }</div>                    
                                    
                    <div className="subtitle">Points &nbsp;<small>(0 - 20)</small></div>
                    <input 
                        type="number"
                        min={0}
                        max={20}
                        {...register("points", { required: "Points is required" })}
                        placeholder="Quiz points"
                        defaultValue={activity['points']}
                    />
                    <div className="error">{errors.points?.message}</div>



                    <div className="reward">
                        <h2>Reward</h2>
                        <div className="subtitle">Name</div>
                        <input
                            type="text"
                            {...register("reward[name]")}
                            placeholder="Reward name"
                            defaultValue={activity['reward'] ? activity['reward']['name'] : ''}
                        />
                        <div className="error">{errors.reward && errors.reward.name?.message}</div>

                        <div className="subtitle">Price</div>
                        <input
                            type="number"
                            min={0}
                            max={1000}
                            {...register("reward[price]")}
                            placeholder="Reward price"
                            defaultValue={activity['reward'] ? activity['reward']['price'] : 5}
                        />
                        <div className="error">{errors.reward && errors.reward.price?.message}</div>

                        <ActivityIcon icon={activity['reward'] ? activity['reward']['image'] : ''} saveIcon={saveRewardIcon} hideIcon={hideRewardIcon} size="512"/>
                    </div>

                    
                    <button type="submit" className="button check save" onClick={handleSubmit(saveButton)}>
                        Save activity
                    </button>
                    <div className="error">{ message }</div>
                    
                </form>                
            
            </div>                                    
            
        </div> 
        
    )

}        
